<template>
  <div>
    <el-popover
      ref="note"
      placement="top-start"
      :width="this.width"
      trigger="hover"
      popper-class="customPop">
      <div>
        <div v-if="!showLink">
          <strong>{{this.text}}</strong>
        </div>
        <div v-if="showLink">
          <strong><div v-html="this.text" style="word-wrap:normal"></div></strong>
        </div>
      </div>
    </el-popover>
    <img src="@/assets/status/question.svg" class="statusIcon" alt="" title="" v-popover:note/>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      default: 350
    },
    showLink: {
      default: false
    },
    linkLabel: {
      default: ''
    },
    link: {
      default: ''
    },
    text: {
      default: 'Please give text'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .statusIcon {
    width: 27px;
    height: 27px;
  }

  .customPop {
    text-align: initial !important;
  }
</style>
